import { defineComponent as _defineComponent } from 'vue'
import Create from '../collections/Create.vue';

type Props = {
  title: string;
};

export default /*#__PURE__*/_defineComponent({
  __name: 'Create',
  props: {
    title: null
  },
  setup(__props: any) {



return { __sfc: true,Create }
}

})